module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-BookOblique.394ebffa.ttf";